// Module
var code = "<vf-button class=\"vf-icon-button\" :size=\"buttonSize\"> <icon :class=\"size\"></icon> <slot>{{ text }}</slot> </vf-button> ";
// Exports
export default code;